import Video from '@/data/Video';
import IVideoSort from '@/utils/IVideoSort';

export default class VideoSortByViews implements IVideoSort {

  public getComparator(): (video1: Video, video2: Video) => number {

    return (video1: Video, video2: Video) => {
      if(!video2.views) return -1;
      if(!video1.views) return 1;
      if(video1.views > video2.views) return -1;
      if(video1.views < video2.views) return 1;
      return 0;
    }
  };

  public sort(videos: Array<Video>, calcOwnPrio?: boolean): Array<Video> {
    if(!videos) return videos;
    return videos.sort(this.getComparator());
  }
}